<ion-content>
    <div class="score-summary">
        <app-int-match-score [match]="match" [tie]="tie" [summaryView]="true" [matchTotalScore]="matchTotalScore"></app-int-match-score>
        <div class="mixed-set-score {{themeService?.isDarkMode ? 'dark' : 'light'}}">
            <strong>{{matchCollectionName}}</strong>
            <div class="set-body">
              <app-int-body [match]="match" [tie]="tie" [summaryView]="true"></app-int-body>
            </div>
        </div>
    </div>
</ion-content>